
elm = require('../../../../elm/elm.js')
import { connect } from '../../global/socket_subscriber.coffee'

$ ->
  if $('.alert-app-container').length > 0
    $('.alert-app-container').each () ->
      mobile = $(this).data('mobile')
      flags = $(this).data('flags')
      userId = $(this).data('userid')
      app = elm.AlertCenterMain.embed($(this).get(0), flags)
      dispatch = app.ports.alertCenterIn.send

      $(document).on 'click', (e) ->
        if $(e.target).closest("#alert-app-container-#{if mobile then 'mobile' else 'desktop'}").length == 0
          dispatch({ tag: "CloseRequest", data: "" })

      app.ports.alertCenterOut.subscribe ({ tag, data }) ->
        switch tag
          when "AppLoaded"
            mobileNavHeight = $('#top_navigation_wrapper').height()
            if mobileNavHeight?
              $('#alert-app-container-mobile .alerts-container').css('margin-top', "#{mobileNavHeight}px")
          else
            console.warn("Un-recgonized Message from AlertCenter: ", msg)
      connect({ channel: 'ApplicationAlertsChannel', user_id: Number(userId) },
        ({ msg, data }) ->
          switch msg
            when 'Connected'
              console.log('Alert Center Connected')
              dispatch({ tag: 'WebsocketConnected', data: '' })
            when 'Disconnected'
              dispatch({ tag: "WebsocketDisconnected", data: '' })
            when 'Rejected'
              dispatch({ tag: "WebsocketDisconnected", data: '' })
            when 'Received'
              dispatch({ tag: "ApplicationAlertReceived", data: JSON.parse(data.alert)})
      )
